module.exports = __webpack_public_path__ + "img/img1@2x-no-bg-5.d96f6509.png";